/**
 * NotificationGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { NotificationData } from './notification_data'

/**
 * NotificationGetRes
 */
export interface NotificationGetRes {
  /** 通知详情 */
  items?: NotificationData[]
}

/**
 * NotificationGetRes Schema
 */
export const NotificationGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '通知详情',
      format: '[]*model.NotificationData',
      items: { $ref: 'NotificationData', description: '' },
      type: 'array',
      label: '通知详情',
    },
  },
  type: 'object',
}
